import { render, staticRenderFns } from "./GradientCard.vue?vue&type=template&id=9489e70a&scoped=true&"
import script from "./GradientCard.vue?vue&type=script&lang=js&"
export * from "./GradientCard.vue?vue&type=script&lang=js&"
import style0 from "./GradientCard.vue?vue&type=style&index=0&id=9489e70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9489e70a",
  null
  
)

export default component.exports